import Service from '@/calendesk/models/DTO/Response/Service'
import ServiceType from '@/calendesk/models/DTO/Response/ServiceType'
import Employee from '@/calendesk/models/DTO/Response/Employee'
import moment from 'moment/moment'
import { DateTimeFormats } from '@/calendesk/models/DateTimeFormats'
import Product from '@/calendesk/models/DTO/Response/Product'
import { ServiceLocationType } from '@/calendesk/models/DTO/Response/ServiceLocationType'

export default class BookingEvent {
  public id: string
  public service: Service
  public employee: Employee
  public serviceType: ServiceType | null
  public startDate: string
  public startTime: string
  public endDate: string
  public endTime: string
  public selectedDuration: number | null
  public customerTimeZone: string | null
  public selectedProducts: Array<Product> = []
  public userRequestedEmployee: boolean
  public locationId: ServiceLocationType | null

  public constructor (
    service: Service,
    employee: Employee,
    serviceType: ServiceType | null,
    startDate: string,
    startTime: string,
    endDate: string | null = null,
    endTime: string | null = null,
    selectedDuration: number | null = null,
    customerTimeZone: string | null = null,
    userRequestedEmployee = false,
    locationId: ServiceLocationType | null = null
  ) {
    this.id = (Math.random() + 1).toString(36).substring(2)
    this.service = service
    this.employee = employee
    this.serviceType = serviceType
    this.startDate = startDate
    this.startTime = startTime
    this.selectedDuration = selectedDuration
    this.customerTimeZone = customerTimeZone
    this.userRequestedEmployee = userRequestedEmployee
    this.locationId = locationId

    if (!endDate || !endTime) {
      const duration = serviceType ? serviceType.duration : service.duration
      const endDateTime = moment(this.startDate + ' ' + this.startTime).add(duration, 'minutes')

      this.endDate = endDateTime.format(DateTimeFormats.FULL)
      this.endTime = endDateTime.format(DateTimeFormats.TIME)
    } else {
      this.endDate = endDate
      this.endTime = endTime
    }
  }

  public getDuration () {
    if (this.serviceType) {
      return this.serviceType.duration
    }

    return this.service.duration
  }

  public getPrice () {
    let basePrice = this.service.price
    if (this.serviceType) {
      basePrice = this.serviceType.price
    }

    let productPrice = 0

    if (this.selectedProducts) {
      this.selectedProducts.forEach(product => {
        productPrice += product.price
      })
    }

    return basePrice + productPrice
  }

  public getName () {
    if (this.serviceType) {
      return this.service.name + ' (' + this.serviceType.name + ')'
    }

    return this.service.name
  }

  public sameDay () {
    return this.startDate === this.endDate
  }

  public getSelectedProductIds (): number[] {
    if (this.selectedProducts && this.selectedProducts.length > 0) {
      return this.selectedProducts.map(product => product.id)
    }

    return []
  }
}
